import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import background from '../../../assets/Ich.png';

export const Wrapper = styled(Box)(() => ({
    display: "flex",
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '25px',
    background: `url(${background})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
}));

export const StyledTypography = styled('span')(() => ({
    color: 'blue',
    ':hover': {
        cursor: 'pointer'
    }
}));